export default __webpack_public_path__ + "static/media/music.5c1875f2.jpeg";